import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

class Error extends Component {
  render(){
      return (
        <Grid
            item
            xs={12}
            sm={12}
            md={12}
            xl={12}
            style={{textAlign:"center"}}
            >
            <Typography
              variant="caption"
              style={{color:"white"}}
            >
                
                Error al cargar Información 
            </Typography>
        </Grid>
      );
  }
  
}


export default compose(withRouter)(Error);
